import {
  CAMPAIGN_STEP_CONVERSION_QUERY_PARAM_KEY,
  IBrand,
  ICandidateCalendarEvent,
  IOrganisation,
  IPatientConfirmGapOfferTokenData,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, toMomentTz, WithRef } from '@principle-theorem/shared';
import { createCSRF } from '@principle-theorem/temporary-tokens';
import * as moment from 'moment-timezone';
import { TimezoneResolver } from '../../timezone';
import { Organisation } from '../organisation/organisation';

export async function generateGapOfferToken(
  org: WithRef<IOrganisation>,
  gapOffer: WithRef<ICandidateCalendarEvent>
): Promise<string> {
  const tokenData: IPatientConfirmGapOfferTokenData = {
    gapOffer: gapOffer.ref,
  };
  const timezone = await TimezoneResolver.fromEvent(gapOffer.event);

  const tokenExpiry = toMomentTz(gapOffer.event.from, timezone).add(1, 'week');

  const csrf = await createCSRF(
    Organisation.temporaryTokenCol(org),
    tokenData,
    tokenExpiry,
    moment(tokenExpiry).add(1, 'week'),
    true
  );

  return csrf.tokenUid;
}

export async function generateGapOfferUrl(
  gapOffer: WithRef<ICandidateCalendarEvent>,
  appUrl: string,
  conversionUid?: string
): Promise<string> {
  const brandRef = Firestore.getParentDocRef<IBrand>(gapOffer.ref.path);
  const orgRef = Firestore.getParentDocRef<IOrganisation>(brandRef.path);
  const token = await generateGapOfferToken(
    await Firestore.getDoc(orgRef),
    gapOffer
  );

  const url = [appUrl, 'reschedule', token].join('/');

  if (conversionUid) {
    return `${url}?${CAMPAIGN_STEP_CONVERSION_QUERY_PARAM_KEY}=${conversionUid}`;
  }

  return url;
}
